<template>
  <div 
    id="header"
    class="ProjectBeknopt" 
    v-if="slug !== null && slug !== 'error' && projectData !== false">

    <BtnExtend extend :slug="slug" />
    
    <HeaderSection 
      :title="`Verhaal: ${title}`"
      :mediaImageSrc="afbeelding"
      :closeLinkTo="{name: 'list-projecten'}"
      :mediaLinkTo="{name: 'project-extended', params: { slug }}">
      <SimpleTable :data="tableData" />
    </HeaderSection>

    <ContentSection v-if="projectData.summary">
      <p v-html="projectData.summary" />
      <Link 
        arrow
        label="Lees verder in de tijdlijn"
        :to="{name: 'project-extended', params: { slug }}" />
    </ContentSection>
    <ContentSection v-if="partijen.length !== 0" >
      <SectionHeader label="BETROKKEN PARTIJEN" />
      <Tags :tags="partijen" />
      <!-- compact :limit="5" -->

      <!-- <Link 
        arrow
        label="Bekijk meer betrokken partijen"
        :to="{name: 'project-extended', params: { slug }}" /> -->
    </ContentSection>

    <ContentSection v-if="themas.length !== 0" >
      <SectionHeader label="THEMAS" />
      <Tags :tags="themas"  /> 
      <!-- compact :limit="5" -->

      <!-- <Link 
        arrow
        label="Bekijk meer thema's"
        :to="{ name: 'project-extended', params: { slug } }" /> -->
    </ContentSection>
    
  </div>
</template>

<script>
import Basis from './ProjectBasis';

import Link from '@/components/Link';
import BtnExtend from '@/components/buttons/Extend';
import SectionHeader from '@/components/section/Header';
import ContentSection from '@/components/section/ContentSection';
import HeaderSection from '@/components/section/HeaderSection';
import SimpleTable from '@/components/content/SimpleTable';
import Tags from '@/components/lists/Tags';

export default {
  name: 'ProjectBeknopt',
  components: {
    Link, 
    BtnExtend,
    SectionHeader,
    ContentSection,
    HeaderSection,
    SimpleTable,
    Tags
  },
  extends: Basis
}
</script>

<style lang="scss">
  .ProjectBeknopt {
    position: relative;
    display: flex;
    flex-direction: column;
  }
</style>
